import React from "react";

function Colors_Australia() {
  return (
    <div>
      <h1>Colors_Australia Component</h1>
      <p>This is the Colors Australia tutorial page content.</p>
    </div>
  );
}

export default Colors_Australia;
